// Mock data for Ana Rodrigues website

export const navItems = [
  { label: 'Sobre', href: '#sobre' },
  { label: 'Serviços', href: '#servicos' },
  { label: 'Portfólio', href: '#portfolio' },
  { label: 'Para Quem', href: '#paraquem' },
  { label: 'Depoimentos', href: '#depoimentos' },
  { label: 'FAQ', href: '#faq' },
];

// Ana's photos (customer-provided assets)
export const heroImages = {
  main: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_social-media-demo-3/artifacts/vdsf4k9a_Foto%201.webp',   // Início do site (Hero)
  about: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_social-media-demo-3/artifacts/ehnp5jt0_Foto%203.webp',  // "Prazer, eu sou Ana Rodrigues"
  cta: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_social-media-demo-3/artifacts/wot7gyvd_Foto%202.webp',    // Final do site (CTA)
};

export const marqueeTags = [
  'Social Media',
  'Videomaker',
  'Fotografia',
  'Estratégia de Marca',
  'Conteúdo com Alma',
];

export const services = [
  {
    number: '01',
    title: 'Gestão de Redes Sociais',
    tagline: 'Planejamento estratégico completo para fortalecer sua marca e gerar resultados consistentes.',
    description:
      'Cuido da sua presença digital de ponta a ponta: linha editorial, calendário de conteúdo, criação de posts e stories, legendas estratégicas e análise de métricas. Tudo pensado para transformar seguidores em clientes.',
    bullets: [
      'Linha editorial & calendário',
      'Criação de posts e stories',
      'Gestão de comunidade',
      'Relatórios de métricas',
    ],
  },
  {
    number: '02',
    title: 'Produção de Vídeos',
    tagline: 'Conteúdo audiovisual profissional para Instagram, eventos, marcas e lançamentos.',
    description:
      'Roteiro, captação, direção e edição pensados para conectar com o seu público. Vídeos institucionais, reels, cobertura de eventos e campanhas, sempre com uma estética que respira a alma da sua marca.',
    bullets: [
      'Reels e conteúdo para Instagram',
      'Vídeos institucionais',
      'Cobertura de eventos',
      'Edição e pós-produção',
    ],
  },
  {
    number: '03',
    title: 'Fotografia Profissional',
    tagline: 'Imagens que traduzem a essência da sua marca com qualidade e identidade visual.',
    description:
      'Ensaios pessoais, corporativos, de produto e ambientação. Uma fotografia com direção de arte, luz cuidada e sensibilidade estética, feita para o seu banco de imagens autêntico.',
    bullets: [
      'Ensaios pessoais e corporativos',
      'Fotografia de produto',
      'Ambientação e estilo de vida',
      'Banco de imagens exclusivo',
    ],
  },
  {
    number: '04',
    title: 'Tráfego Pago',
    tagline: 'Campanhas estratégicas no Meta Ads para ampliar seu alcance e captar novos clientes.',
    description:
      'Estruturo campanhas com objetivo claro, criativos que conversam com a sua audiência e acompanhamento próximo dos resultados. Investimento inteligente, retorno mensurável.',
    bullets: [
      'Estratégia Meta Ads',
      'Criativos otimizados',
      'Segmentação avançada',
      'Relatórios de performance',
    ],
  },
];

// Vídeos hospedados no Google Drive
// thumbnail: https://drive.google.com/thumbnail?id={ID}&sz=w1000
// preview iframe: https://drive.google.com/file/d/{ID}/preview
export const portfolioVideos = [
  { id: 1, driveId: '10ijmQhZsaH0G2r0cWHHOyqOGf8gPQjjb' },
  { id: 2, driveId: '1YO5lYhrxK60MOgQnfpH_LFMQjgHjZWts' },
  { id: 3, driveId: '1jEBmKvj9YaqhZyKI5UZdSIOV1R8sLFTD' },
  { id: 4, driveId: '1TztPQbaMMYADNmbzr15FnoINeumVnlnF' },
];

// Posts estáticos — embed direto do Canva (mostra as fotos reais dos designs)
// URL padrão: https://www.canva.com/design/{DESIGN_ID}/{TOKEN}/view?embed
export const portfolioPosts = [
  {
    id: 1,
    slots: 9,
    designId: 'DAHORCbM8e0',
    token: 'h2nFDGOMB1e5XlM1j9JRqw',
    canvaUrl: 'https://canva.link/t4nt5q42x0sasds',
  },
  {
    id: 2,
    slots: 7,
    designId: 'DAHNakwaSfQ',
    token: 'm5RscF0_0T03st13KB4MJw',
    canvaUrl: 'https://canva.link/pihbfi3zrieqjns',
  },
  {
    id: 3,
    slots: 11,
    designId: 'DAHRVP6l9Wo',
    token: 'p9y5U-3CETWYKnc4Lz7iYw',
    canvaUrl: 'https://canva.link/be93ztcekivr1i3',
  },
  {
    id: 4,
    slots: 5,
    designId: 'DAHRVWmy6z4',
    token: 'iDoxmvLvjGgQzsI9ykPRAA',
    canvaUrl: 'https://canva.link/x408tltifxgvbae',
  },
];

export const paraQuem = [
  {
    number: '01',
    title: 'Para Marcas & Empresas',
    description:
      'Negócios que querem presença digital consistente, com identidade forte e comunicação que gera resultado, não só curtidas.',
  },
  {
    number: '02',
    title: 'Para Especialistas & Clínicas',
    description:
      'Médicos, dentistas e profissionais liberais que precisam transmitir confiança e autoridade para atrair os pacientes certos.',
  },
  {
    number: '03',
    title: 'Para Marcas Pessoais',
    description:
      'Empreendedores e criadores que desejam construir uma marca pessoal magnética e coerente em todas as plataformas.',
  },
];

export const testimonials = [
 {
    text: 'A Ana é uma profissional excelente e tem contribuído de forma muito significativa para o nosso negócio. Desde a criação de conteúdo até a visão estratégica, ela trouxe mais clareza, organização e direcionamento para pontos importantes da nossa comunicação e do nosso posicionamento. O trabalho de social media é impecável: pontual, bem executado, com qualidade, profissionalismo e muito comprometimento. É uma parceria que vem se fortalecendo a cada dia. A Ana entregou, na prática, aquilo que muitos prometeram e não cumpriram. Um ponto que considero muito positivo é que ela trabalha com uma quantidade limitada de clientes, e isso faz diferença na entrega. O serviço não se torna genérico, corrido ou superficial. Pelo contrário: existe atenção, cuidado, estratégia e qualidade em cada detalhe. Ela não é uma profissional que busca apenas volume ou ganho financeiro. É alguém que realmente preza pela qualidade do trabalho e pelo resultado que entrega. Isso, hoje em dia, é uma raridade. Parabéns pelo comprometimento, Ana. Que possamos seguir cada vez mais longe, mantendo esse padrão de excelência e essa qualidade de serviço que você vem demonstrando até aqui.',
    name: 'Instituto Dra Ludimila Santiago',
    role: '',
  },
  {
    text: 'Excelente profissional! Facilita muito a gravação, super atenciosa e pontual com as postagens! Recomendo!',
    name: 'Hellen Diniz Abreu',
    role: '',
  },
  {
    text: 'Excelente profissional. Recomendo',
    name: 'Silvano Rocha',
    role: '',
  },
  {
    text: 'Excelente profissional, muito atenciosa aos detalhes, sagaz, tive uma ótimaaa experiência!',
    name: 'Joyce Rodrigues',
    role: '',
  },
];

export const faqs = [
  {
    q: 'O que faz um Social Media e como ele pode ajudar minha empresa a crescer?',
    a: 'Um Social Media cuida da presença da sua marca nas redes: define estratégia, cria conteúdo, gerencia a comunidade e analisa métricas. Isso significa mais visibilidade, autoridade e, principalmente, mais clientes qualificados chegando até você.',
  },
  {
    q: 'Vale a pena contratar um Social Media para minha empresa?',
    a: 'Se você quer sair do postar por postar e transformar suas redes em um canal real de vendas e autoridade, sim. O investimento se paga na consistência, no tempo que você economiza e nos resultados que aparecem.',
  },
  {
    q: 'Qual o investimento para contratar um Social Media?',
    a: 'Depende do escopo: número de plataformas, quantidade de vídeos, fotos, ads. Trabalho com pacotes personalizados. O ideal é conversarmos para eu entender o seu momento e desenhar a melhor proposta.',
  },
  {
    q: 'O que está incluso na gestão de redes sociais?',
    a: 'Linha editorial, calendário, criação de posts e stories, legendas estratégicas, gestão de comunidade, relatórios mensais e reuniões de alinhamento. Tudo pensado para a sua marca crescer com estratégia.',
  },
  {
    q: 'Vocês fazem apenas vídeos para Instagram ou preciso contratar a gestão completa?',
    a: 'Você pode contratar apenas a produção de vídeos, apenas fotografia, apenas tráfego pago ou o pacote completo. Cada projeto é adaptado à sua necessidade.',
  },
  {
    q: 'Vocês produzem vídeos profissionais para empresas em Belo Horizonte?',
    a: 'Sim! Atendo presencialmente em Belo Horizonte e região metropolitana, com equipamento profissional e direção completa. Também atendo remotamente para outras cidades.',
  },
  {
    q: 'A produção de fotografia está incluída na gestão das redes sociais?',
    a: 'Depende do pacote contratado. Em alguns planos incluo um ensaio mensal; em outros, a fotografia é um serviço à parte. Vamos ajustar conforme sua necessidade.',
  },
  {
    q: 'Vocês trabalham apenas com Instagram?',
    a: 'Não. Instagram é o principal, mas também atuo em Facebook, TikTok, LinkedIn e YouTube, sempre com uma estratégia pensada para cada canal.',
  },
];

export const whatsappLink =
  'https://wa.me/message/BB7SOJ2YSS4TP1?text=Ol%C3%A1%2C%20Ana!%20Quero%20falar%20com%20voc%C3%AA%20sobre%20um%20projeto.';

export const instagramUrl =
  'https://www.instagram.com/anastorymaker_socialmidia?igsh=MTZqd3IxNmo0Zm9jYQ%3D%3D&utm_source=qr';
